module.exports = __webpack_public_path__ + "static/media/dress-placeholder.9a02ac2c.svg";